import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Icon from 'Components/UI/Icon';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    marginTop: '-15px', //  Match the Demographic margin. We can't change this because it's (1) we only show this compoment conditionally and (2) in use on the dashboard
    marginBottom: '30px',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    '& i': {
      marginRight: '28px',
      backgroundSize: '100%',
    },
  },
  title: {
    color: '#898989',
    fontWeight: '400',
  },
}));

const AssetsManaged = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.column}>
        <Icon icon="assetsUnderManagement" height="38px" width="38px" />
      </div>
      <div className={classes.column}>
        <Typography className={classes.title} variant="h6">
          Assets Under Management
        </Typography>
      </div>
    </div>
  );
};

export default AssetsManaged;
